import { JSX } from 'react';
import { CloseIcon } from '@bg-components/Icon';
import classes from './ModalClose.module.scss';

interface IProps {
    onClose(): void;
    className?: string;
}

export const ModalClose = (props: IProps): JSX.Element => (
    <button
        data-qa="button-modal-close"
        type="button"
        onClick={props.onClose}
        className={props.className}
    >
        <CloseIcon className={classes.icon} />
    </button>
);
